module.exports = __webpack_public_path__ + "font_hui.bbc6e0d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/font_hui.png
// module id = IMpw
// module chunks = 0